/* eslint-disable-next-line import/no-restricted-paths */
import { getAuthMotivationCookie, setAuthMotivationCookie } from '../../../browser/utils/cookies';
import { FAVORITES_LIMIT_FOR_UNAUTHENTICATED_USER } from '../../constants/favorites';
import { selectIsFavorite } from '../../selectors/favorite';
import { selectNewbuildingId } from '../../selectors/newbuilding';
import { selectIsUserAuthenticated } from '../../selectors/user';
import { addNewbuildingToFavorites } from '../../services/addNewbuildingToFavorites';
import { removeNewbuildingFromFavorites } from '../../services/removeNewbuildingFromFavorites';
import { TThunkAction } from '../../types/redux';
import { changeFavoriteState, changeMotivationPopupState } from './actions';

export function toggleFavorite(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, { httpApi, logger }) => {
    const state = getState();

    const isFavorite = selectIsFavorite(state);
    const newbuildingId = selectNewbuildingId(state);
    const isUserAuthenticated = selectIsUserAuthenticated(state);

    const currentFavoritesCount = window.__header_favorites_count__ || 0;
    const isFavoritesLimit = currentFavoritesCount >= FAVORITES_LIMIT_FOR_UNAUTHENTICATED_USER;
    const isAddToFavorite = !isFavorite;

    if (isAddToFavorite && !isUserAuthenticated && isFavoritesLimit && window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
      dispatch(changeFavoriteState(isFavorite));

      return;
    }

    const motivationCookie = getAuthMotivationCookie();
    const isFavoritesEmpty = currentFavoritesCount === 0;

    if (isAddToFavorite && !motivationCookie && !isUserAuthenticated && isFavoritesEmpty) {
      dispatch(changeMotivationPopupState(true));
      setAuthMotivationCookie();
    }

    dispatch(changeFavoriteState(isAddToFavorite));

    try {
      if (isAddToFavorite) {
        await addNewbuildingToFavorites(httpApi, { newbuildingId });
      } else {
        await removeNewbuildingFromFavorites(httpApi, { newbuildingId });
      }

      if (window.__header_favorites_count__) {
        window.__header_favorites_count__ = window.__header_favorites_count__ + (isAddToFavorite ? 1 : -1);
      }

      if (window.__header_updateFavorites__) {
        window.__header_updateFavorites__(isAddToFavorite);
      }

      dispatch(changeFavoriteState(isAddToFavorite));
    } catch (error) {
      logger.error(error);
      dispatch(changeFavoriteState(isFavorite));
    }
  };
}
